import {
  Form,
  Input,
  InputNumber,
  DatePicker,
  Select,
  Space,
  Switch,
} from "antd";
import WrappingModal from "../../../../../components/Modals/WrappingModal";
import { useGetCurrenciesQuery } from "../../../../../redux/Service/currenciesApi";
import { useGetAccountsQuery } from "../../../../../redux/Service/Accounts";
import dayjs from "dayjs";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  currencies?: any;
  accounts?: any;
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  currencies,
  accounts,
}: Props) => {
  const currencyOptions =
    currencies?.map((cur) => ({
      label: cur.CurrName,
      value: cur.CurrID,
    })) || [];

  const accountOptions =
    accounts?.map((acc) => ({
      label: acc.AccName,
      value: acc.AccID,
    })) || [];

  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل بنك" : "إضافة بنك"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          ...initialValues,
          FirstBalDate: initialValues?.FirstBalDate
            ? dayjs(initialValues.FirstBalDate)
            : null,
        }}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {isEditing && (
              <Form.Item
                name="BankID"
                label="كود البنك"
                rules={[{ required: true }]}
              >
                <Input disabled placeholder="كود البنك" />
              </Form.Item>
            )}
            <Form.Item
              name="BankName"
              label="اسم البنك"
              rules={[{ required: true }]}
            >
              <Input placeholder="اسم البنك" />
            </Form.Item>

            <Form.Item
              name="CurrID"
              label="العملة"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="اختر العملة"
                options={currencyOptions}
                showSearch
              />
            </Form.Item>

            <Form.Item
              name="CurrRate"
              label="سعر العملة"
              rules={[{ required: true }]}
            >
              <InputNumber className="w-full" placeholder="سعر العملة" />
            </Form.Item>

            <Form.Item
              name="AccId"
              label="رقم الحساب"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="اختر الحساب"
                options={accountOptions}
                showSearch
              />
            </Form.Item>

            <Form.Item
              name="FirstBalDate"
              label="تاريخ الرصيد الافتتاحي"
              rules={[{ required: true }]}
            >
              <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item
              name="FirstBal"
              label="الرصيد الافتتاحي"
              rules={[{ required: true }]}
            >
              <InputNumber className="w-full" placeholder="رصيد ابتدائي" />
            </Form.Item>

            <Form.Item
              name="IsCredit"
              label="رصيد دائن"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item name="IsDebit" label="رصيد مدين" valuePropName="checked">
              <Switch />
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
